import React from 'react'
import Notifications from "./notifications.svg";


function NotificationsIcon() {
    return <img src={Notifications} alt="Notifications Icon" />;

}

export default NotificationsIcon